import { gql } from "@apollo/client";

export const GET_ALL_SURGICAL_ACTS = gql`
  query SurgicalActById($id: ID!) {
    surgicalActById(_id: $id) {
      _id
      actNature
      vertebra
      value
      details
    }
  }
`;

export const GET_SURGICAL_ACT_BY_ID = gql`
  query SurgicalActById($id: ID!) {
    surgicalActById(_id: $id) {
      _id
      actNature
      vertebra
      value
      details
    }
  }
`;

export const GET_SURGICAL_ACTS_BY_IDS = gql`
  query SurgicalActsByIds($ids: [ID!]!) {
    surgicalActsByIds(ids: $ids) {
      _id
      actNature
      vertebra
      value
      details
    }
  }
`;
